import PDMPdp from "@tw/product-discovery-merchandizing-cra/lib/pdp/pdp-master-nextjs";
import PageWrapper from "../wrappers/page-wrapper";

PDMPdp.domainName = "product-discovery";

export default PageWrapper(PDMPdp);
